<template>
  <transition name="fade">
    <v-alert
      v-if="visible"
      :type="notification.style && !notification.color ? notification.style : undefined"
      :color="notification.color || undefined"
      :elevation="2"
      :border="border"
      colored-border
      class="toast-alert"
      @click="handleClick"
      dismissible
      close-icon="mdi-close"
      @input="handleClose"
    >
      <div class="toast-content">
        <strong>{{ notification.title }}</strong><br />
        <span>{{ notification.body }}</span>
      </div>
    </v-alert>
  </transition>
</template>

<script>
export default {
  name: 'NotificationToast',
  props: {
    notification: {
      type: Object,
      required: true,
    },
    timeout: {
      type: Number,
      default: 25000,
    },
    border: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      visible: true,
      clickedManually: false,
    };
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.visible = false;
    }, this.timeout);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    handleClick() {
      this.clickedManually = true;
      this.visible = false;
    },
    handleClose(val) {
      if (!val && this.clickedManually) {
        this.$emit('clicked', this.notification);
      }
      // Always emit 'closed' to remove from stack
      if (!val) {
        this.$emit('closed', this.notification);
      }
    },
  },
};
</script>

<style scoped>
.toast-alert {
  max-width: 360px;
  margin-bottom: 10px;
  cursor: pointer;
  overflow: hidden;           /* prevent the left border overflow */
  padding-left: 16px !important; /* override Vuetify's border padding */
  border-left-width: 4px !important;
}
.toast-content {
  pointer-events: none; /* prevent inner text triggering click */
}
</style>
